import useGetBranch from "@/shared/hooks/useGetBranch";
import { useSteps } from "@/shared/hooks/useGetSteps";
import { Flex, Typography } from "antd";
import { type FC } from "react";
import { useLocation } from "react-router-dom";
import useHeaderStyles from "./Header.styles";

interface HeaderProps {}

const Header: FC<HeaderProps> = () => {
  const { styles } = useHeaderStyles();
  const { handleBack } = useSteps();

  const location = useLocation();
  const branchId = location.pathname.split("/").at(-1);

  const { branchData } = useGetBranch();

  return (
    <Flex className={styles.header} justify="center" align="center">
      {branchId && (
        <Flex onClick={handleBack} className="icon" justify="center" align="center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="black"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </Flex>
      )}

      <Typography.Text className="headerText">{branchData?.branch.name}</Typography.Text>
    </Flex>
  );
};
export default Header;
